/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Security32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 13v-2a4 4 0 018 0v2h1a2 2 0 012 2v8a2 2 0 01-2 2H11a2 2 0 01-2-2v-8a2 2 0 012-2h1zm6-2v2h-4v-2a2 2 0 114 0zm-1.998 10.699a.63.63 0 01-.566.301.671.671 0 01-.543-.266l-1.713-1.627a.793.793 0 01-.14-.233.69.69 0 01-.04-.233.64.64 0 01.174-.459.58.58 0 01.438-.182c.192 0 .35.08.474.238l1.34 1.174 2.422-4.076a.742.742 0 01.236-.26.57.57 0 01.3-.076.58.58 0 01.44.182.632.632 0 01.176.456c0 .065-.01.134-.031.205a.907.907 0 01-.1.219l-2.867 4.637z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default Security32;
